import { render } from "./IndexTicket.vue?vue&type=template&id=1b976158"
import script from "./IndexTicket.vue?vue&type=script&lang=js"
export * from "./IndexTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__